import { Crown } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-4">
      <div className="text-center">
        <Crown className="w-24 h-24 text-purple-400 mx-auto mb-8" />
        <h1 className="text-6xl font-bold text-white mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-300 mb-4">System Not Found</h2>
        <p className="text-gray-400 mb-8 max-w-md mx-auto">
          The coordinates you're looking for seem to have drifted into uncharted space.
        </p>
        <a
          href="/"
          className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium rounded-lg transition-colors"
        >
          Return to Command Center
        </a>
      </div>
    </div>
  )
}

export default NotFound